const PT = require("prop-types");
const AT = require("../vault/ActionTypes");
const _ = require("lodash");
const React = require("react");
const createReactClass = require("create-react-class");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const OfficeModalClose = require("./OfficeModalClose");

const styles = require("./styles/TeacherModal.css");
const sizeStyles = require("./styles/ModalGeneral.css");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const URLMake = require("../../../shared/URLMake");
const clsx = require("clsx");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "TeacherModal",

		propTypes: {
			size: PT.string,
			heightAuto: PT.bool, // If true, the modal will be as tall as the content
			onClose: PT.func,
			levelType: PT.string,
			buttonTexts: PT.arrayOf(PT.string),
			buttonClickHandlers: PT.arrayOf(PT.func),
			buttonDisabled: PT.arrayOf(PT.bool),
			modalClass: PT.string,
			portalContainer: PT.string,
			cannotClose: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {
				portalContainer: PORTAL_CONTAINERS.TRAINER_MESSAGE,
				levelType: "default",
			};
		},

		startLogout: function(loginWith) {
			let logoutPage = URLMake.state.forOffice();
			if (loginWith) {
				// Student, but might not have a username to use with forLoginWith
				logoutPage = URLMake.state.forLogin();
				if (loginWith.username)
					logoutPage = URLMake.state.forLoginWith(loginWith.username);
			}
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				logoutPage,
				/**
				 * Safari inexplicably flips out when a user clicks the Play button
				 * then signs in as another user, citing what looks like a CORS
				 * issue. However, a refresh on the signin page fixes this... so
				 * we're gonna do that.
				 */
				triggerRefresh: true,
			});
		},

		render: function() {
			const {
				portalContainer,
				onClose,
				cannotClose,
				buttonDisabled,
				buttonTexts,
				buttonClickHandlers,
				children,
				size,
				heightAuto,
				levelType,
				modalClass,
			} = this.props;
			const modalClasses = clsx(
				modalClass,
				styles.modal,
				size && sizeStyles[size],
				heightAuto && styles.heightAuto
			);

			const hasLongText =
				buttonTexts && _.find(buttonTexts, t => t.length > 12);
			const buttons =
				buttonTexts &&
				buttonTexts.map((text, i) => {
					let onClick = buttonClickHandlers[i];
					let buttonClass = hasLongText ? styles.buttonLarge : styles.button;
					if (buttonDisabled && buttonDisabled[i]) {
						buttonClass += " " + styles.disabled;
						onClick = null;
					}
					return (
						<div className={buttonClass} onClick={onClick} key={"button-" + i}>
							{text}
						</div>
					);
				});
			const closeButton = cannotClose ? null : (
				<OfficeModalClose handleClose={onClose} />
			);
			return (
				<div>
					<Modal
						portalContainer={portalContainer}
						onClose={onClose}
						closeOnBackdropClick={!cannotClose}
						closeOnEsc={!cannotClose}
						hasCloseButton={false}
						backdropClass={styles.backdrop}
						modalClass={modalClasses}
						levelType={levelType}
					>
						{closeButton}
						{children}
						<div className={styles.buttons}>{buttons}</div>
					</Modal>
				</div>
			);
		},
	})
);
